import { usePubNubInit } from '@/utils/pubnub/usePubNubInit';

export const PubNubInit = () => {
  usePubNubInit();
  return null;
};
